import React, { createContext, useCallback, useContext, useState } from 'react';
import { Exhibitor, VoucherType } from '../dtos';

type State = {
    exhibitors: Exhibitor[];
    setExhibitors: React.Dispatch<React.SetStateAction<Exhibitor[]>>;
    subtractDistributedAmount: (exhibitor: Exhibitor, type: VoucherType, amount: number) => void;
};

type Props = {
    children: React.ReactNode;
};

const ExhibitorContext = createContext<State>({} as State);

const ExhibitorProvider: React.FC<Props> = ({ children }) => {
    const [exhibitors, setExhibitors] = useState<Exhibitor[]>([]);

    const subtractDistributedAmount = useCallback((exhibitor: Exhibitor, type: VoucherType, amount: number) =>
        setExhibitors(oldExhibitors =>
            oldExhibitors.map(oldExhibitor => oldExhibitor.id === exhibitor.id ? ({
                ...oldExhibitor,
                voucherTypes: oldExhibitor.voucherTypes.map(oldVoucherType => oldVoucherType.id === type.id ? ({
                    ...oldVoucherType,
                    amount: oldVoucherType.amount - amount
                }) : oldVoucherType)
            }) : oldExhibitor
            )), []);

    return (
        <ExhibitorContext.Provider
            value={{
                exhibitors,
                setExhibitors,
                subtractDistributedAmount
            }}
        >
            {children}
        </ExhibitorContext.Provider>
    );
};

const useExhibitor = (): State => {
    const context = useContext(ExhibitorContext);

    return context;
}

export { ExhibitorProvider, useExhibitor };